module.exports = __webpack_public_path__ + "static/zhongjiaoxingxue.196c3c90.jpg";